import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[fixed-top]'
})

export class FixedTopDirective {
    
    constructor(private elementRef: ElementRef) {}
    
    private menuBlock = this.elementRef.nativeElement;

    @HostListener("window:scroll") onScroll() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const MAX_TOP_OFFSET = 116;

        if(scrollPosition >= MAX_TOP_OFFSET) {
           this.menuBlock.classList.add('fixed');
        } else {
           this.menuBlock.classList.remove('fixed');
        }
     }
}
